import { POSITIVE_INTEGER } from '@openx/components-form/validationRegexes.ts';
import { AdFormat } from '@openx/types/gqlTypes.ts';
import type { TFunction } from 'i18next';
import { type InferType, mixed, object, string } from 'yup';
import { getBaseFieldsValidation } from './baseValidation.ts';

const MAX_DIMENSION = 10000;
// const BANNER_MARKUP_TYPES = [MarkupType.Html, MarkupType.Xml, MarkupType.JavaScript, MarkupType.Image];

export const getBannerCreativeSchema = (t: TFunction) => {
  return object({
    ...getBaseFieldsValidation(t),

    ad_format: mixed<typeof AdFormat.Banner>()
      .oneOf([AdFormat.Banner], t('Ad format must be banner'))
      .required(t('Ad format is required')),

    // markup_type: mixed<MarkupType>()
    //   .oneOf(BANNER_MARKUP_TYPES, t('Markup type must be one of: HTML, XML, JavaScript, or Image for banner creatives'))
    //   .required(t('Markup type is required')),

    width: string()
      .required(t('Width is required for banner creatives'))
      .matches(POSITIVE_INTEGER, t('Width must be a positive integer'))
      .test('minimum-width', t('Width must be at least 1 pixel'), value => !value || parseInt(value, 10) >= 1)
      .test(
        'maximum-width',
        t('Width must not exceed 10,000 pixels'),
        value => !value || parseInt(value, 10) <= MAX_DIMENSION
      ),

    height: string()
      .required(t('Height is required for banner creatives'))
      .matches(POSITIVE_INTEGER, t('Height must be a positive integer'))
      .test('minimum-height', t('Height must be at least 1 pixel'), value => !value || parseInt(value, 10) >= 1)
      .test(
        'maximum-height',
        t('Height must not exceed 10,000 pixels'),
        value => !value || parseInt(value, 10) <= MAX_DIMENSION
      ),
  }).strict();
};

/**
 * Type inference for Banner creative form data
 * Automatically includes width and height fields
 */
export type BannerCreativeFormData = InferType<ReturnType<typeof getBannerCreativeSchema>>;
